'use strict';

module Patersons {


  export interface PortfolioViewScope extends ng.IScope {
    events: Patersons.PortfolioViewCtrl;
    accounts: Array<Account>;
    selectedAccount: Account;
    selectedAccountTotals: SelectedAccountTotal;
    accountToCompare: Account;
    isLoading: boolean;
  }


  //export class PortfolioViewCtrl extends AbstractController {
  export class PortfolioViewCtrl extends PortfolioBaseCtrl {
    scope: Patersons.PortfolioViewScope;
    q: ng.IQService;
    filter: ng.IFilterService;
    portfolioService: Patersons.PortfolioService;

    static $inject = ['$scope', '$log', '$q', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'navigationService'];

    constructor($scope, $log, $q, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, navigationService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.q = $q;
      this.filter = $filter;
      this.portfolioService = portfolioService;

      this.scope.events = this;
      this.load();
    }

    setSelectedAccount(accountId: string) {
      this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
      this.checkCompareMethod();
    }

    setAccountToCompare(accountId: string) {
      this.scope.accountToCompare = this.scope.accounts.filter(a => a.accountId == accountId)[0];
      this.checkCompareMethod();
    }

    load() {
      var promise = this.portfolioService.getCombinedPortfolioData();
      promise.then((result: Array<Account>) => {
        this.scope.accounts = result;

        if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
          this.scope.selectedAccount = this.scope.accounts[0];
          this.loadXray();
        }
      });
    }

    loadXray() {

      if (this.scope.selectedAccount == undefined) {
        return;
      }

      this.loadShares([this.scope.selectedAccount])
        .then(() => {
          this.mapAccountToPortfolio(this.scope.selectedAccount).then(result => {
            console.log(JSON.stringify(result['holdings']));
            var xrayComponent = morningstar.asterix.instanceRegistry.get('ecXray')
            xrayComponent.setParameter('portfolio', result);
          });

        });
    }

    loadCompare() {

      this.loadShares([this.scope.selectedAccount, this.scope.accountToCompare])
        .then(() => {
          this.log.info("compare " + this.scope.selectedAccount.accountId + ' with ' + this.scope.accountToCompare.accountId);
          this.mapAccountToPortfolio(this.scope.selectedAccount).then(myPortfolio1 => {
            this.mapAccountToPortfolio(this.scope.accountToCompare).then(myPortfolio2 => {

              morningstar.asterix.instanceRegistry.get('ecPortfolioCompare.xrayCurrent').setParameter('portfolio', myPortfolio1);
              morningstar.asterix.instanceRegistry.get('ecPortfolioCompare.xrayProposed').setParameter('portfolio', myPortfolio2);
            });
          });



        });
    }

    loadShares(accounts: Account[]) {
      let q = this.q;
      let portfolioService = this.portfolioService;
      var getShares = [];

      angular.forEach(accounts, function(account) {
        if (account !== undefined && account.holdings === undefined) {

          let promise = null;
          if (account.accountType === 'Standard') {
            promise = portfolioService.getCombinedShares(account.accountId);

          } else {
            promise = portfolioService.getAccoladeHoldings(account.accountId);
          }
          getShares.push(promise
            .then(result => {
              console.info('Getting shares for account ' + account.accountId);

              console.log(result);
              account.holdings = result;

            })
            .catch(response => {
              console.error('Error getting shares for account ' + account.accountId, response.status, response.data);
            }));
        }
      });

      let deferred = q.defer();

      return q.all(getShares)
        .then(() => {
          deferred.resolve();
          return deferred.promise;
        })
        .catch(response => {
          console.error('Error loading shares', response.status, response.data);

          deferred.reject(response);

          return deferred.promise;
        });
    }

    checkCompareMethod() {
      if (this.scope.accountToCompare != null) {
        this.loadCompare();
      }
      else {
        this.loadXray();
      }
    }

    createHoldingForAssetAllocation(item: Holding) {
      var holdings = [];
      if (item.assetAllocationDomesticCash != 0) {
        holdings.push(this.createCustomHoldingsForCashAccolade(item.assetAllocationDomesticCash, item.companyName));
      }

      if (item.assetAllocationDomesticEquity != 0) {
        holdings.push(this.createCustomHoldingsForAustralianEquity(item.assetAllocationDomesticEquity, item.companyName));
      }

      if (item.assetAllocationDomesticFixedInterest != 0) {
        holdings.push(this.createCustomHoldingsForAUFixedIncome(item.assetAllocationDomesticFixedInterest, item.companyName));
      }

      if (item.assetAllocationDomesticProperty != 0) {

        // Add addition checks here for the Exchange Code
        if (item.exchange.toLowerCase() === "nsx" || item.exchange.toLowerCase() === "chi-x") {
          holdings.push(this.createCustomHoldingsForProperty(item.marketValue, item.companyName));
        }
        else {
          if (item.exchange.toLowerCase() === "axw") {
            holdings.push(this.createCustomHoldingsForOther(item.assetAllocationOther, item.companyName));
          }
          else {
            holdings.push(this.createCustomHoldingsForUnlistedProperty(item.marketValue, item.companyName));
          }
        }

      }

      if (item.assetAllocationInternationalCash != 0) {
        holdings.push(this.createCustomHoldingsForCashAccolade(item.assetAllocationInternationalCash, item.companyName));
      }

      if (item.assetAllocationInternationalEquity != 0) {
        holdings.push(this.createCustomHoldingsForInternationalEquity(item.assetAllocationInternationalEquity, item.companyName));
      }

      if (item.assetAllocationInternationalFixedInterest != 0) {
        holdings.push(this.createCustomHoldingsForIntlFixedIncome(item.assetAllocationInternationalFixedInterest, item.companyName));
      }

      if (item.assetAllocationInternationalProperty != 0) {
        holdings.push(this.createCustomHoldingsForInternationalProperty(item.assetAllocationInternationalProperty, item.companyName));
      }

      if (item.assetAllocationOther != 0) {
        holdings.push(this.createCustomHoldingsForOther(item.assetAllocationOther, item.companyName));
      }

      return holdings;
    };

    createCustomHoldingsForCashAccolade(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 100,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 100,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForAustralianEquity(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 100,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 100,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForInternationalEquity(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 100,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 100,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForProperty(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 100,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 100,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForUnlistedProperty(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 100,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 100,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForInternationalProperty(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 100,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 100,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForAUFixedIncome(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 100,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 100,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForIntlFixedIncome(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 100,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 100,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForCash(balance, securityName) {
      return {
        "identifier": "Cash",
        "identifierType": "ISIN",
        "Name": "Cash",
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 100,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 100,
                "8": 0,
                "9": 0,
                "10": 0
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    createCustomHoldingsForOther(balance, securityName) {
      return {
        "identifier": securityName,
        "identifierType": "ISIN",
        "Name": securityName,
        "weight": balance,
        "Proxy": 1,
        "breakdowns": {
          "assetAllocation": [
            {
              "type": "MorningstarAUS10",
              "salePosition": "N",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 100
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "L",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 100
              }
            },
            {
              "type": "MorningstarAUS10",
              "salePosition": "S",
              "values": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ]
        }
      }
    }

    mapAccountToPortfolio(account: Account) {

      return new Promise((resolve, reject) => {
        console.info('mapAccountToPortfolio:');

        console.info(account);
        var allHoldings = [];

        var totalAccountValue = 0;
        for (var holdingItem of account.holdings) {
          totalAccountValue = totalAccountValue + holdingItem.marketValue;
        }
        if (account.accountType === "Standard") {
          console.log("standard account map account to portfolio");
          var totalCashHoldingsValue = 0;

          for (var i = 0; i < account.holdings.length; i++) {
            if (account.holdings[i].isin === "unknown") {

              allHoldings.push(this.createCustomHoldingsForOther(account.holdings[i].marketValue, account.holdings[i].companyName));
            }
            else {
              var holding = {
                identifier: account.holdings[i].isin,
                identifierType: 'ISIN',
                weight: account.holdings[i].marketValue
              };

              allHoldings.push(holding);
            }
          }

          // Standard Account Type
          // Get Cash Accounts
          this.portfolioService.getCashAccounts(account.accountId)
            .then(result => {
              console.info('Getting cash account for: ' + account.accountId);
              console.log("Cash: " + JSON.stringify(result));

              if (result && result.length > 0) { // need to sum up
                result.forEach((cashItem) => {
                  totalAccountValue += cashItem.balance;
                  totalCashHoldingsValue += cashItem.balance;
                });
              }
            }).then(() => {
              // Get High Interest Cash Accounts
              this.portfolioService.getHighInterestCashAccounts(account.accountId)
                .then(result => {
                  console.info('Getting High Interest Cash account for: ' + account.accountId);
                  console.log("High Interest Cash: " + JSON.stringify(result));

                  /*if (result.length > 0) {
                      totalAccountValue = totalAccountValue + result[0].balance;
                      totalCashHoldingsValue = totalCashHoldingsValue + result[0].balance;
                  }*/
                  if (result && result.length > 0) { // need to sum up
                    result.forEach((cashItem) => {
                      totalAccountValue += cashItem.balance;
                      totalCashHoldingsValue += cashItem.balance;
                    });
                  }
                }).then(() => {
                  // Get Term Deposits
                  this.portfolioService.getTermDeposits(account.accountId)
                    .then(result => {
                      console.info('Getting Term Deposit account for: ' + account.accountId);
                      console.log("Term Deposit: " + JSON.stringify(result));
                      if (result != null && result.length > 0) {

                        result.forEach((item) => {

                          allHoldings.push(this.createCustomHoldingsForAUFixedIncome(item.balance, item.provider));
                        });
                      };

                    }).then(() => {
                      if (totalCashHoldingsValue > 0) {
                        allHoldings.push(this.createCustomHoldingsForCash(totalCashHoldingsValue, "Cash"));
                      }

                      var portfolio = {
                        name: this.filter<any>("accountName")(account.designation ? account.designation.slice(1,-1) : account.accountName),
                        totalValue: totalAccountValue,
                        currencyId: 'AUD',
                        holdings: allHoldings,
                        benchmark: {
                          holdings: [{
                            identifier: 'XXXXXXXXXX',
                            identifierType: 'MSID',
                            weight: 100
                          }]
                        }
                      }
                      resolve(portfolio);

                    });
                })
            });
        }
        else {
          console.log(account.holdings);

          account.holdings.forEach((item) => {
            if (item.isin === "unknown") {
              //when no isin is present, assign the holdings to categories based on the asset allocation percentage
              var assetAllocations = this.createHoldingForAssetAllocation(item);
              assetAllocations.forEach((allocation) => {
                allHoldings.push(allocation);
              });
            }
            else {
              var holding = {
                identifier: item.isin,
                identifierType: 'ISIN',
                weight: item.marketValue
              };
              allHoldings.push(holding);
            }
          });

          console.log(JSON.stringify(allHoldings));

          var portfolio = {
            name: this.filter<any>("accountName")(account.designation ? account.designation.slice(1,-1) : account.accountName),
            totalValue: totalAccountValue,
            currencyId: 'AUD',
            holdings: allHoldings,
            benchmark: {
              holdings: [{
                identifier: 'XXXXXXXXXX',
                identifierType: 'MSID',
                weight: 100
              }]
            }
          }
          resolve(portfolio);
        }

      });

    };


  }
}
